export default __webpack_public_path__ + "static/media/order.43b078a9.svg";